function showDocumentHistoryIcon({ className }: { className?: string }) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="14.5" transform="rotate(-90 15 15)" fill="#18468F" stroke="#18468F"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M20.7803 12.2366C21.0732 12.5624 21.0732 13.0907 20.7803 13.4165L15.5303 19.2568C15.2374 19.5826 14.7626 19.5826 14.4697 19.2568L9.21967 13.4165C8.92678 13.0907 8.92678 12.5624 9.21967 12.2366C9.51256 11.9107 9.98744 11.9107 10.2803 12.2366L15 17.4869L19.7197 12.2366C20.0126 11.9107 20.4874 11.9107 20.7803 12.2366Z" fill="white"/>
    </svg>
  );
}
export default showDocumentHistoryIcon;